<template >
    <div class="pages memberGroup">
        <el-radio-group @change="typeCk" v-model="tabPosition" style="margin-bottom: 30px;">
            <el-radio-button label="1">自定义渠道</el-radio-button>
            <el-radio-button label="2">小程序渠道</el-radio-button>
        </el-radio-group>
        <div class="f1 mb-30">
            <div class="d1">
                积木云提供全渠道全触点会员数据与会员事件分析
            </div>
            <div class="d2">
                <div class="text" v-if="tabPosition==1">
                    <p>
                        您还未配置渠道模版，请先配置渠道模版，让渠道引流更有效。
                    </p>
                </div>
                <div class="text" v-if="tabPosition==2">
                    <p>
                          企业可根据实际引流场景创建不同渠道，便于验证渠道有效性与引流率。详细查看：<span>渠道场景文档</span>
                    </p>
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="content1" v-show="tabPosition==1">
            <div class="title mb-15">
                <p>
                    <img src="../../assets/images/newIcon/template_icon.png" alt="">
                    <span>渠道模版</span>
                </p>
                <p>
                    <el-button class="btn-12" @click="addImport" type="primary" round><img src="../../assets/images/newIcon/recommend_addvip_icon.png" alt=""> 新建模板</el-button>
                    <!-- <span>规则配置</span> -->
                </p>
            </div>
            <div class="f2 mb-30">
                <div class="li">
                    <div>
                        <img src="../../assets/images/icons/gouwu_pc.png" alt="">
                        <p>年终购物盛典</p>
                    </div>
                    <div class="foot_btn">
                        <p @click="addImport">
                            <img src="../../assets/images/newIcon/configurationtemplate_icon.png" alt="">
                            <span>配置模版</span>
                        </p>
                        <p @click="showImg">
                            <img src="../../assets/images/newIcon/preview_icon.png" alt="">
                            <span >预览</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <img src="../../assets/images/icons/haoli_pc.png" alt="">
                        <p>好礼集结</p>
                    </div>
                    <div class="foot_btn">
                        <p @click="addImport">
                            <img src="../../assets/images/newIcon/configurationtemplate_icon.png" alt="">
                            <span>配置模版</span>
                        </p>
                        <p @click="showImg">
                            <img src="../../assets/images/newIcon/preview_icon.png" alt="">
                            <span>预览</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <img src="../../assets/images/icons/neirong_pc.png" alt="">
                        <p>内容落地页</p>
                    </div>
                    <div class="foot_btn">
                        <p @click="addImport">
                            <img src="../../assets/images/newIcon/configurationtemplate_icon.png" alt="">
                            <span>配置模版</span>
                        </p>
                        <p @click="showImg">
                            <img src="../../assets/images/newIcon/preview_icon.png" alt="">
                            <span>预览</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <img src="../../assets/images/icons/youhui_pc.png" alt="">
                        <p>送福利领优惠</p>
                    </div>
                    <div class="foot_btn">
                        <p @click="addImport">
                            <img src="../../assets/images/newIcon/configurationtemplate_icon.png" alt="">
                            <span>配置模版</span>
                        </p>
                        <p @click="showImg">
                              
                            <img src="../../assets/images/newIcon/preview_icon.png" alt="">
                            <span>预览</span>
                        </p>
                       
                    </div>
                </div>
            </div>
            <div class="f3">
                <div class="ipt">
                    <p>
                        <el-input
                        class="iptRdio"
                        placeholder="根据渠道名称进行搜索"
                        suffix-icon="el-icon-search"
                        v-model="query.keyword_search"
                        ></el-input>
                        <el-select class="iptRdio" v-model="value" placeholder="请选择业务渠道">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </p>
                    <p>
                         <el-radio-group style="margin-right:40px;" v-model="createChl" >
                            <el-radio-button label="1">APP</el-radio-button>
                            <el-radio-button label="2">小程序</el-radio-button>
                            <el-radio-button label="3">网页</el-radio-button>
                        </el-radio-group>
                        <el-button class="btn-12" @click="addChannel" type="primary" round><img src="../../assets/images/newIcon/addchannel_icon.png" alt="">新增渠道</el-button>
                    </p>
                </div>
                <el-table
                :data="createChl==1 ? tableData3 : createChl==2 ? tableData4 : tableData2"
                :header-cell-style="{background:'#EEEEEE',fontSize:'12px',textAlign: 'center'}"
                 :cell-style="{fontSize:'12px',textAlign: 'center'}"
                style="width: 100%;"
                >
                <!-- <el-table-column
                type="selection"
                width="55">
                </el-table-column> -->
                <el-table-column
                prop="name"
                label="渠道名称"
                
                >
                </el-table-column>

                <el-table-column
                prop="number"
                label="渠道描述"
                show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="类型"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="应用模版"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                label="新增客户"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员标签"
                width="240"
                >
                    <template slot-scope="scope">
                        <div class="labelLi">
                            <p>标签111</p>
                            <p>标签222</p>
                            <el-popover
                            placement="bottom"
                            width="200"
                            trigger="click">
                            <div class="labelAll">
                                <el-tag>标签一</el-tag>
                                <el-tag>标签一</el-tag>
                            </div>
                            <span class="s" slot="reference">...</span>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员等级"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员积分"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width='280'
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="goDetail(scope.row.type)">详情</el-button>
                        <el-button type="text" @click="edit(111)">编辑</el-button>
                        <el-button @click="viewUser" type="text">查看用户</el-button>
                        <el-button @click="yuny" type="text">去运营</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="content2" v-show="tabPosition==2">
           <div class="f2 mb-30">
                <div class="title" style="margin-bottom:15px;">
                    <p>
                        <img src="../../assets/images/newIcon/ss_shi_icon.png" alt="">
                        <span>实时渠道</span>
                    </p>
                    <p>
                        运营关键数值与小程序打开方式的关系占比
                    </p>
                </div>
                <el-radio-group style="margin-right:40px;margin-bottom:30px;" v-model="quTab" >
                    <el-radio-button label="1">PV</el-radio-button>
                    <el-radio-button label="2">UV</el-radio-button>
                    <el-radio-button label="3">成交金额</el-radio-button>
                    <el-radio-button label="4">成交订单数</el-radio-button>
                    <el-radio-button label="5">成交用户数</el-radio-button>
                    <el-radio-button label="6">新客户</el-radio-button>
                </el-radio-group>
                <div id="e1" v-if="tabPosition==2"></div>
           </div>
           <div class="f3">
                <div class="title " style="padding:15px 30px;">
                    <p>
                        <img src="../../assets/images/newIcon/list_icon.png" alt="">
                        <span>明细表</span>
                    </p>
                    <p>
                        小程序细分场景数值展示
                    </p>
                </div>
               <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                style="width: 100%;"
                >
                <el-table-column
                prop="name1"
                label="场景名称"
                >
                </el-table-column>
                <el-table-column
                prop="name3"
                label="新客户"
                >
                </el-table-column>
                <el-table-column
                prop="name4"
                label="PV"
                >
                </el-table-column>
                <el-table-column
                prop="name5"
                label="UV"
                >
                </el-table-column>
                <el-table-column
                prop="name6"
                label="成交金额"
                >
                </el-table-column>
                <el-table-column
                prop="name7"
                label="成交订单数"
                >
                </el-table-column>
                <el-table-column
                prop="name7"
                label="成交用户数"
                >
                </el-table-column>
               </el-table>

           </div>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <el-image-viewer
            v-if="showViewer"
            :on-close="closeViewer"
            :url-list="srcList"
        />
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { Chart } from "@antv/g2";
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            showViewer:false,
            url:"https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
            srcList:['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
            createChl:1,
            quTab:"1",
            query:JSON.parse(JSON.stringify(QUERY)),
            tabPosition:1,
            value:"",
            options: [{
            value: '选项1',
            label: '全部'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }, {
            value: '选项3',
            label: '颐安中台'
            }, {
            value: '选项4',
            label: '业务系统3'
            }],
            tableData3: [{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                type:"1",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                type:"2",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                type:"3",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"APP",
                labellv:"模版名称",
                names:"100"
            },],
            tableData2: [{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                type:"1",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                type:"2",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                type:"3",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"网页",
                labellv:"模版名称",
                names:"100"
            },],
            tableData4: [{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                type:"1",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                type:"2",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                type:"3",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                labellv:"模版名称",
                names:"100"
                },{
                name: '渠道名称1',
                number:"描述文字描述描述文字描述描述文字描述描述文字描述描述文字描述",
                xmember:"颐安中台",
                lmember:"小程序",
                labellv:"模版名称",
                names:"100"
            },],
            tableData: [{
                name1: '快捷入口',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '模版消息',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '搜索打开',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '扫描小程序码',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '公众号文章',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '公众号菜单',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },{
                name1: '长按识别',
                name2:"100",
                name3:"4,323",
                name4:"4,323",
                name5:"100",
                name6:"100",
                name7:"100"
                },],
            total:90,
            type:1
        }
    },
    mounted(){
        // this.init();
    },
     components: {
            ElImageViewer
    },
    methods: {
        showImg(){
            // this.url = img
            this.showViewer = true;
        },
        closeViewer(){
             this.showViewer = false;
        },
        viewUser(){
            this.$router.push({name:"memberList"})
        },
        yuny(){
            this.$router.push({name:'newMarketingPlan'})
        },
        edit(id){
            this.$router.push({name:'newChannel',query:{id}})
        },
        goDetail(type){
            // console.log(type)
            this.$router.push({name:"channelDetails",query:{id:'11111',type:this.createChl}});
        },
        addChannel(){
            this.$router.push({name:"newChannel",query:{type:this.newChannel}});
        },
        typeCk(e){
            if(e==2){
                this.init();
            }
            // console.log(e);
        },
        init() {
            const data = [
                { type: "快捷入口", value: 300 },
                { type: "搜索", value: 85 },
                { type: "其他", value: 103 },
                { type: "公众号", value: 142 },
                { type: "微信聊天", value: 400 }
            ];
            const chart = new Chart({
                container: "e1",
                autoFit: true,
                height: 350,
            });
            chart.data(data);
            chart.scale({
                value: {
                max: 500,
                min: 0,
                alias: "PV",
                },
            });
            //
            // chart.axis(true);
            // chart.axis("type", {
            //     title: null,
            //     tickLine: null,
            //     line: null,
            // });

            // chart.axis("value", {
            //     label: null,
            //     title: {},
            // });
             // 显示Y轴的竖线
            chart.axis("value", {
                line: {
                style: {
                    lineWidth: 1,
                    stroke: "#BFBFBF",
                },
                },
            });
              // 自定义图例
            chart.legend({
                custom: true,
                items: [
                {
                    name: "pv",
                    id: "type",
                    marker: { symbol: "square", style: { r: 4, fill: "#6395f9" } },
                },
                ],
            });
            // chart.legend(false);
            chart.coordinate().transpose();
            chart
                .interval()
                .position("type*value")
                .size(26)
                .label("value", {
                style: {
                    fill: "#8d8d8d",
                },
                offset: 10,
                });
            chart.interaction("element-active");
            chart.render();
        },
        goAnal(){
             this.$router.push({name:"populationAnalysis",query:{id:22222}})
        },
        addImport(){
            this.$router.push({name:"newTemplate",query:{id:"1111"}})
        },
        chageType(t){
            this.type=t;
        },
        handleSizeChange(val) {
            this.query.page_size = val;
            // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
    },
}
</script>
<style>
    .el-popover{
        min-width: 80px !important;
    }
</style>
<style lang="less" scoped>
    /deep/ .el-input__suffix{
        height:auto;
    }
    .memberGroup{
        /deep/ .el-radio-button:first-child .el-radio-button__inner{
            border-radius: 18px 0 0 18px;
        }
        /deep/ .el-radio-button:last-child .el-radio-button__inner{
            border-radius: 0 18px 18px 0;
        }
        .content1{
            .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:24%;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    div{
                        &:first-child{
                            img{
                                width:100%;
                                height: 200px;
                                border-radius: 6px 6px 0 0;
                                object-fit: cover;
                            }
                            p{
                                padding:10px 6px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                            }
                           
                        }
                        &:last-child{
                            display: flex;
                            border-top:1px solid #EDEDED;
                            p{
                                &:first-child{
                                    border-right:1px solid #ededed;
                                }
                                padding:15px;
                                width:50%;
                                text-align: center;
                                img{
                                    margin-right:10px;
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #3285F8;
                                }
                            }
                        }
                    }
                }
            }
            .f3{
                background: #ffff;
                .ipt{
                    // height:40px;
                    padding:15px;
                    display: flex;
                    justify-content: space-between;
                    /deep/.el-input .el-input__inner{
                        border-radius: 30px;
                        background: #F6F6F6;
                        border: 0px;
                    }
                    /deep/ .el-select>.el-input{
                        width:160px;
                    }
                    .iptRdio{
                        margin-right: 15px;
                    }
                    p{
                        display: flex;
                        img{
                            width:16px;
                            vertical-align: middle;
                        }
                    }
                }
                
                /deep/ .el-button{
                    margin-right:10px;
                }
               
                .labelLi{
                    display: flex;
                    align-items: center;
                    p{
                        margin-right:8px;
                        display: inline-block;
                        width:40px;
                        padding:0px 8px;
                        background: rgba(211, 236, 255, 0.4);
                        border-radius: 15px;
                        border: 1px solid rgba(0, 145, 255, 0.11);
                        font-size: 12px;
                        font-weight: 400;
                        color: #0091FF;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        // &:last-child{
                        //     padding:0 4px;
                        //     text-align: center;
                        //     // border:0;
                        //     // background:#fff;
                        // }
                        
                    }
                    .s{
                        background: rgba(211, 236, 255, 0.4);
                        border: 1px solid rgba(0, 145, 255, 0.11);
                        padding: 2px 10px;
                        color: #0091FF;
                        border-radius: 18px;
                        width: auto;
                    }
                }
                
            }
        }
        .content2{
            .f2{
                background: #fff;
                padding:30px;
                /deep/ .el-radio-button__inner{
                    width:100px;
                }
                // display: flex;
                // justify-content: space-between;
            }
            .f3{
                background: #fff;
                .title{
                    padding:30px 0 0 30px;
                    display: flex;
                    
                    justify-content: flex-start;
                }
            }
             .title{
                display: flex;
                justify-content: flex-start;
            }
        }
    }
    .title{
        display: flex;
        // align-items: center;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin:0px;
                    width:20px;
                    height:20px;
                }
            }
            &:last-child{
                margin-left:20px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 24px;
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 6%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 21px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
                letter-spacing: 7px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
    }
    .labelAll{
        .el-tag{
            margin-right:10px;
            margin-bottom:6px;
            border-radius: 18px;
        }
    }
    .page{
        /deep/ .el-pagination .btn-prev{
            margin-right:10px;
        }
        /deep/ .el-pagination .btn-next{
            margin-left:10px;
        }
    }
    .ged{
        p{
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            &:first-child{
                color:#327EFF;
                padding-bottom:8px;
                border-bottom:1px solid #EFEFEF;
            }
            &:last-child{
                padding-top:8px;
            }
        }
    }
</style>